<template>
  <el-tabs type="border-card" stretch>
    <el-tab-pane label="涨幅榜">
      <el-table
        :data="gainsData"
        stripe
        size="mini"
        height="600px"
      >
        <el-table-column
          min-width="70px"
          prop="name"
          label="名称">
          <template slot-scope="scope">
            <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol}}" class="stockLinkColor">
              <span >{{ scope.row.name }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          label="涨跌幅"
          align="right">
          <template slot-scope="scope">
<!--            <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>-->
<!--            <span class="red" v-else>{{ scope.row.changepercent }}%</span>-->
            <span class="red" >{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="最近">
      <el-table
        :data="tableData"
        stripe
        size="mini"
        height="600px"
        >
        <el-table-column
          min-width="70px"
          prop="symbolName"
          label="名称">
          <template slot-scope="scope">
            <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol}}" class="stockLinkColor">
              <span >{{ scope.row.symbolName }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          label="涨跌幅"
          align="right">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>
            <span class="red" v-else>{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="自选">
      <div  v-show="$store.state.loginType">
        <el-table
          :data="concernData"
          stripe
          size="mini"
          height="600px"
        >
          <el-table-column
            prop="symbolName"
            label="名称">
            <template slot-scope="scope">
              <router-link :to="{name:'Stockdetailed',query:{symbol:scope.row.symbol}}" class="stockLinkColor">
                <span >{{ scope.row.symbolName }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="trade"
            label="价格"
            align="center">
          </el-table-column>
          <el-table-column
            prop="changepercent"
            label="涨跌幅"
            align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>
              <span class="red" v-else>{{ scope.row.changepercent }}%</span>
              <el-button size="mini" type="text" icon="el-icon-circle-close" @click="cancel_concern(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="center" v-show="!$store.state.loginType" style="height: 600px">
        <router-link to="/login">
          <el-button type="primary" >请登录</el-button>
        </router-link>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import eventBus from "../assets/js/eventBus";
  import $ from "jquery";
    export default {
      name: "stockcard",
      data() {
        return {
          // tableData: this.$store.state.stockVisited,
          concernData:[],
          gainsData:[]
        }
      },
      computed: {
        tableData: function () {
          return this.$store.state.stockVisited
        },
      },
      methods:{
        getCardInfo(){
          let that = this;
          let stockVisited = that.tableData;
          that.chatTimer = setInterval(function() {
            that.getStockInfo(stockVisited)
          }, 1000);
        },
        getStockInfo(stockVisited){
          let that = this;
          if (stockVisited.length !== 0){
            let shortArr = [];
            for (let i = 0, len = stockVisited.length; i < len; i++){
              shortArr.push(stockVisited[i].symbol);
            }
            that.getNewPrice(shortArr,stockVisited)
          }
        },
        getNewPrice(shortArr,dataArr) {
          let that = this;
          $.ajax({
            url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var i, elements;
              for (i = 0; i < shortArr.length; i++) {
                var elements = eval("v_" + shortArr[i]).split("~");
                dataArr[i].trade = elements[3];
                dataArr[i].changepercent = elements[32];
              }
              that.$store.commit('changeStocksVisited',dataArr);
            }
          });
        },
        getUserConcern(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "POST",
            data: {
              'nozzle': 'concern',
              token: sessionStorage.getItem("token")
            }
          })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                that.getUserConcernInfo(resData.data);
              }
            });
        },
        //获取自选股票详细数据
        getUserConcernInfo(Concern){
          let that = this;
          if (Concern.length !== 0){
            let symbol = '';
            for (let i = 0, len = Concern.length; i < len; i++){
              symbol = symbol + 's_' + Concern[i].short + ',';
            }
            that
              .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'stockdetail',
                'symbol': symbol
              }
            })
              .then(ret => {
                let resData = ret.data;
                if (resData.code === 1){
                  let result = [];
                  for (let i = 0, len = resData.data.length; i < len; i+=10){
                    result.push(resData.data.slice(i,i+10));
                  }
                  result.pop();
                  let temp = [];
                  for (let i = 0, len = Concern.length; i < len; i++){
                    temp[i] = {symbol:Concern[i].short,code:Concern[i].code,symbolName:Concern[i].name,trade:result[i][3],changepercent:result[i][5]};
                  }
                  that.concernData = temp;
                }
              });
          }else{
            let temp = [];
            that.concernData = temp;
          }
        },
        getGainsData(){
          let that = this;
          that
            .$http({
            url: "/",
            method: "post",
            data: {
              'nozzle': 'stockchange',
              'page': 1,
              'asc': 0,
              'num':15
            }
          })  .then(ret => {
            let resData = ret.data;
            if (resData.code === 1){
              that.gainsData = resData.data;
            }else{
              that.$alert('请稍后尝试','提示',{
                confirmButtonText: '确定',
                callback: action => that.getTableData()
              })
            }
          });
        },
        cancel_concern(row){
          let that = this;
          that
            .$http({
              url: "/",
              method: "POST",
              data: {
                'nozzle': 'cancel_concern',
                'token': window.sessionStorage.getItem('token'),
                'code': row.code
              }
            })
            .then(ret => {
              let resData = ret.data;
              if (resData.code === 1){
                this.$message({
                  message: resData.msg,
                  type: 'success',
                  onClose:function () {
                    that.getUserConcern();
                  }
                });
              }else{
                that.$message.error(resData.msg);
              }
            });
        }
      },
      created(){
        let that = this;
        eventBus.$on('concern',()=>{
          that.getUserConcern();
        });
      },
      mounted:function () {
        let that = this;
        this.getCardInfo();
        if (that.$store.state.loginType){
          this.getUserConcern();
        }
        this.getGainsData();
      },
      beforeDestroy() {
        clearTimeout(this.chatTimer);
      }
    }
</script>

<style scoped>
  .green{
    color: #008000;
  }
  .stockLinkColor{
    color: rgb(0,0,238);
  }
  .stockLinkColor :hover{
    color: #0100A0;
  }
</style>



// WEBPACK FOOTER //
// src/components/stockcard.vue